// Status of a device's ARC link check; the result lands in v4ArcDeviceIds.
export const ARC_LINK_CHECK = {
  PENDING: "pending",
  LOADED: "loaded",
  FAILED: "failed",
};

// V3 links a device via `arcKey`; a V4 link lives on the ARC (v4ArcDeviceIds).
export function isHandledByArc(device, user, v4ArcDeviceIds) {
  if (!device) return false;
  if (user?.hasAlarmCenter && device.arcKey) return true;
  return !!device.uuid && !!v4ArcDeviceIds?.has?.(device.uuid);
}

// Not known to be linked and the device's check hasn't answered yet.
export function isArcLinkPending(device, user, v4ArcDeviceIds, v4ArcLinkChecks) {
  if (!device?.uuid) return false;
  if (isHandledByArc(device, user, v4ArcDeviceIds)) return false;
  const check = v4ArcLinkChecks?.get?.(device.uuid);
  return !check || check === ARC_LINK_CHECK.PENDING;
}
